<template>
  <div class="main-layout main-layout_fullpage" v-if="load">
    <!-- orders filter start -->
    <orders-filters />
    <!-- orders filter end -->

    <!-- orders list start -->
    <orders-list />
    <!-- orders list end -->

    <add-btn v-if="$guard('write', 'Requests')" @onClick="toggleShowModalAdd" />

    <modal
      :show="showModal"
      :showBtn="true"
      @close="toggleModal"
      :dark="true"
      :outside="false"
    >
      <transition name="showmodal">
        <orders-modal :large="true" />
      </transition>
    </modal>

    <!-- ADD A NEW ORDERS START -->
    <modal
      :show="showModalAdd"
      :dark="true"
      :outside="false"
      @close="toggleShowModalAdd"
    >
      <transition name="showmodal">
        <request-add-modal v-if="showModalAdd" @close="toggleShowModalAdd" />
      </transition>
    </modal>
    <!-- ADD A NEW ORDERS END -->

    <snackbar
      v-if="snackbar.show"
      :message="$t('forms.snackbarMessage')"
      @reopen="reopen"
      @close="closeSnackbar"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import ordersList from '@/components/lists/orders/ordersList'
import ordersFilters from '@/components/filters/orders/ordersFilters'
import ordersModal from '@/components/modals/orders/ordersModal'
import requestAddModal from '@/components/modals/requests/requestAddModal'
import snackbar from '@/components/controls/snackbar'
import addBtn from '@/components/controls/addBtn'

export default {
    name: 'orders',
    components: {
        ordersList,
        ordersFilters,
        ordersModal,
        requestAddModal,
        snackbar,
        addBtn,
    },
    data() {
        return {
            activeRequest: { calendar: true },
        }
    },
    computed: {
        ...mapGetters({
            showModal: 'orders/showModal',
            load: 'orders/loadGetters',
            orders: 'orders/ordersGetters',
            snackbar: 'orders/snackbar',
            showModalAdd: 'requests/showModalAdd',
        }),
    },
    methods: {
        ...mapMutations({
            toggleModal: 'orders/setToggleModal',
            setToggleModalState: 'orders/setToggleModalState',
            setParams: 'orders/setParams',
            setLoad: 'orders/setLoad',
            setSort: 'orders/setSort',
            clearOrders: 'orders/clearOrders',
            clearParams: 'orders/clearParams',
            toggleShowModalAdd: 'requests/toggleShowModalAdd',
            setSnackbarShow: 'orders/setSnackbarShow',
            setSnackbarData: 'orders/setSnackbarData',
        }),
        ...mapActions({
            fetch: 'orders/fetch',
            fetchMinMaxPrice: 'orders/fetchMinMaxPrice',
            fetchById: 'orders/fetchById',
            addApplication: 'addApplication',
        }),
        async reopen() {
            const { id } = this.snackbar.data
            await this.fetchById(id)
            this.setToggleModalState(true)
            this.setSnackbarShow(false)
        },
        closeSnackbar() {
            this.setSnackbarShow(false)
        },
    },
    async created() {
        if (this.orders === null) {
            await this.fetchMinMaxPrice()
            await this.fetch({ page: 1 })
            this.setLoad(true)

            return
        }

        this.setLoad(true)
    },
    beforeDestroy() {
        this.clearParams()
        this.setLoad(false)
        this.clearOrders()
        this.closeSnackbar()
        this.setToggleModalState(false)

        if (this.showModalAdd) {
            this.toggleShowModalAdd()
        }
    },
    async mounted() {
        this.setSnackbarShow(false)

        if (this.$route.params.requestId) {
            setTimeout(async () => {
                await this.fetchById(this.$route.params.requestId)
                this.setToggleModalState(true)
            }, 300)
        }
    },
}

// window.addEventListener("load", () => {
//   const query = window.location.search;
//   if (!query) return;

//   const $el = document.getElementById("cabinet-link");
// console.log($el.href, query);
// $el.href = `${$el.href.substring(0, $el.href.length - 1)}${query}`;
// console.log(query);
// });
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;

  h2 {
    margin: 40px 42px 10px;
  }
}
</style>
